import { render, staticRenderFns } from "./I2FormInputFile.vue?vue&type=template&id=71a66c14&scoped=true&"
import script from "./I2FormInputFile.vue?vue&type=script&lang=js&"
export * from "./I2FormInputFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a66c14",
  null
  
)

export default component.exports